import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
}

export default function Logo({ variant = 'light', size = 'medium' }: LogoProps) {
  const sizes = {
    small: { padding: '0.5rem 1rem', icon: '1.25rem', text: '0.875rem', subtext: '0.6rem' },
    medium: { padding: '0.75rem 1.25rem', icon: '1.5rem', text: '1rem', subtext: '0.7rem' },
    large: { padding: '1rem 1.5rem', icon: '2rem', text: '1.5rem', subtext: '0.9rem' }
  };

  const currentSize = sizes[size];

  return (
    <Link 
      to="/" 
      style={{ 
        textDecoration: 'none',
        display: 'inline-block'
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
          padding: currentSize.padding,
          borderRadius: '0.75rem',
          transform: 'rotate(-2deg)',
          boxShadow: 'var(--shadow-lg)',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'rotate(-2deg) translateY(-2px)';
          e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'rotate(-2deg)';
          e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
        }}
      >
        <span style={{ fontSize: currentSize.icon }}>📝</span>
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.1' }}>
          <span style={{ 
            fontWeight: 'bold', 
            fontSize: currentSize.text,
            color: variant === 'dark' ? '#0d1117' : 'white',
            letterSpacing: '-0.02em'
          }}>
            meinelisten
          </span>
          <span style={{ 
            fontSize: currentSize.subtext, 
            color: variant === 'dark' ? 'rgba(0,0,0,0.65)' : 'rgba(255,255,255,0.85)',
            fontWeight: '600'
          }}>
            .app
          </span>
        </div>
      </div>
    </Link>
  );
}
